import React, { useContext } from 'react';
import { AddCouponFormContext } from '../../../Context/Coupons/AddCouponFormContext';
import { sanitizeToPositiveInteger } from '../../../lib/utils/utils';

function CouponLimitation() {
    const { formInputs, setFormInputs, limitType, setLimitType, formErrors } = useContext(AddCouponFormContext);

    const handleOptionChange = (event) => {
        setLimitType(event.target.value);
        setFormInputs({ ...formInputs, limitAmount: '' });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const cleanedValue = sanitizeToPositiveInteger(value);
        setFormInputs({ ...formInputs, [name]: cleanedValue });
    };

    return (
        <div className="flex flex-col gap-4 border border-[#EAEAEA] p-5 rounded-xl">
            <div className="flex items-center justify-between">
                <h1 className='font-semibold text-[18px] leading-6 text-[#121212]'>Coupon Limitation</h1>

                <p className='text-[14px] leading-5 text-[#DC2626] select-none'>{formErrors.limitAmount}</p>
            </div>

            <div className="flex flex-col gap-2 w-fit">
                <div className="flex items-center gap-2">
                    <label htmlFor='limit-number-purchase-radio' className="cursor-pointer w-6 h-6 flex items-center justify-center">
                        <div className={`w-4 h-4 rounded-full border flex items-center justify-center ${limitType === 'limit-number-purchase' ? 'border-primaryColor' : 'border-[#757575]'}`}>
                            {
                                limitType === 'limit-number-purchase' && 
                                <div className="w-2 h-2 rounded-full bg-primaryColor"></div>
                            }
                        </div>
                    </label>

                    <label htmlFor="limit-number-purchase-radio" className='font-normal text-[16px] leading-8 text-[#121212] cursor-pointer select-none'>
                        <input 
                            id='limit-number-purchase-radio'
                            value='limit-number-purchase' 
                            type="radio" 
                            checked={limitType === 'limit-number-purchase'} 
                            onChange={handleOptionChange} 
                            className='hidden' 
                        />
                        Limitate number of purchase
                    </label>
                </div>

                {
                    limitType === 'limit-number-purchase' && 
                    <input 
                        name='limitAmount' 
                        className='w-[200px] h-14 ml-8 border border-[#EAEAEA] bg-[#F5F5F5] px-2 py-[6px] rounded-lg outline-none font-medium text-[14px] leading-5 text-[#121212] placeholder:text-[#666666] focus:border-primaryColor' 
                        type='text' 
                        placeholder='0' 
                        value={formInputs.limitAmount} 
                        onChange={handleChange} 
                    />
                }

                <div className="flex items-center gap-2">
                    <label htmlFor='limit-order-per-customer-radio' className="cursor-pointer w-6 h-6 flex items-center justify-center">
                        <div className={`w-4 h-4 rounded-full border flex items-center justify-center ${limitType === 'limit-order-per-customer' ? 'border-primaryColor' : 'border-[#757575]'}`}>
                            {
                                limitType === 'limit-order-per-customer' && 
                                <div className="w-2 h-2 rounded-full bg-primaryColor"></div>
                            }
                        </div>
                    </label>

                    <label htmlFor="limit-order-per-customer-radio" className='font-normal text-[16px] leading-8 text-[#121212] cursor-pointer select-none'>
                        <input 
                            id='limit-order-per-customer-radio'
                            value='limit-order-per-customer' 
                            type="radio" 
                            checked={limitType === 'limit-order-per-customer'} 
                            onChange={handleOptionChange} 
                            className='hidden' 
                        />
                        Limitate as an order per customer
                    </label>
                </div>

                {
                    limitType === 'limit-order-per-customer' && 
                    <input 
                        name='limitAmount' 
                        className='w-[200px] h-14 ml-8 border border-[#EAEAEA] bg-[#F5F5F5] px-2 py-[6px] rounded-lg outline-none font-medium text-[14px] leading-5 text-[#121212] placeholder:text-[#666666] focus:border-primaryColor' 
                        type='text' 
                        placeholder='0' 
                        value={formInputs.limitAmount} 
                        onChange={handleChange} 
                    />
                }

                <div className="flex items-center gap-2">
                    <label
                        htmlFor="no-limit-radio"
                        className="cursor-pointer w-6 h-6 flex items-center justify-center"
                    >
                        <div
                        className={`w-4 h-4 rounded-full border flex items-center justify-center ${
                            limitType === "no-limit"
                            ? "border-primaryColor"
                            : "border-[#757575]"
                        }`}
                        >
                        {limitType === "no-limit" && (
                            <div className="w-2 h-2 rounded-full bg-primaryColor"></div>
                        )}
                        </div>
                    </label>

                    <label
                        htmlFor="no-limit-radio"
                        className="font-normal text-[16px] leading-8 text-[#121212] cursor-pointer select-none"
                    >
                        <input
                        id="no-limit-radio"
                        value="no-limit"
                        type="radio"
                        name="limitAmount"
                        checked={limitType === "no-limit"}
                        onChange={handleOptionChange}
                        className="hidden"
                        />
                        No Limitation
                    </label>
                </div>
            </div>
        </div>
    );
}

export default CouponLimitation;
